import { mergeAttributes, Node } from "@tiptap/core";

const CB_ATTR = "data-cb";
const CB_PREFIX = "data-cb-";

export const CustomBlock = Node.create<{
  HTMLAttributes: Record<string, unknown>;
}>({
  name: "customBlock",

  group: "block",

  content: "block+",

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      blockType: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute(CB_ATTR),
        renderHTML: (attributes: Record<string, unknown>) => {
          if (!attributes.blockType) {
            return {};
          }
          return { [CB_ATTR]: attributes.blockType };
        },
      },
      blockAttrs: {
        default: {},
        parseHTML: (element: HTMLElement) => {
          const result: Record<string, string> = {};
          for (const attr of Array.from(element.attributes)) {
            if (attr.name.startsWith(CB_PREFIX)) {
              result[attr.name.slice(CB_PREFIX.length)] = attr.value;
            }
          }
          return result;
        },
        renderHTML: (attributes: Record<string, unknown>) => {
          const blockAttrs = attributes.blockAttrs as Record<string, string> | undefined;
          if (!blockAttrs) {
            return {};
          }
          const out: Record<string, string> = {};
          for (const [key, value] of Object.entries(blockAttrs)) {
            if (typeof value === "string") {
              out[`${CB_PREFIX}${key}`] = value;
            }
          }
          return out;
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `div[${CB_ATTR}]`,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
});
